import { Slider, InputNumber, Flex } from "antd"
import { useContext, useMemo } from "react"
import {
    CustomizeMoneyFlowContext,
    MoneyFlowContext,
} from "../../../context/MoneyFlowContext.tsx"
import { formatter } from "../../../utils/formatterUSD.ts"

// The slider runs on a log scale: edge amounts span many orders of magnitude
// ($0.01 to $100M+), so on a linear one any useful threshold sat at its very
// start, the handle not moving as the amount changed. 0 is its left end.
const STEPS = 1000

export const Threshold = () => {
    const { setThreshold } = useContext(CustomizeMoneyFlowContext)
    const { threshold, sankeyData } = useContext(MoneyFlowContext)

    const { min, max } = useMemo(() => {
        const amounts = (sankeyData?.Edges ?? []).map((edge) => edge.AmountUSD || 0).filter((amount) => amount > 0)
        const max = amounts.length ? Math.max(...amounts) : 0
        return { min: amounts.length ? Math.min(...amounts, max / 1e6) : 0, max }
    }, [sankeyData])

    const toPosition = (amount: number) => {
        if (amount <= 0 || max <= min) return amount > 0 ? STEPS : 0
        const position = Math.round(STEPS * Math.log(amount / min) / Math.log(max / min))
        return Math.min(STEPS, Math.max(1, position))
    }
    const toAmount = (position: number) => {
        if (position <= 0 || max <= 0) return 0
        if (max <= min) return max
        // Three significant digits, rounded down so the edge at the handle stays
        const amount = min * (max / min) ** (position / STEPS)
        const unit = 10 ** (Math.floor(Math.log10(amount)) - 2)
        return Math.min(amount, Number((Math.floor(amount / unit) * unit).toPrecision(3)))
    }

    return (
        <>
            <Slider
                style={{ width: 200 }}
                onChange={(position) => setThreshold(toAmount(position))}
                value={toPosition(threshold)}
                min={0}
                max={STEPS}
                step={1}
                tooltip={{ formatter: (position) => formatter.format(toAmount(position ?? 0)) }}
            />
            <Flex gap={4} align="center">
        Threshold:
                <InputNumber
                    size="small"
                    prefix="$"
                    min={0}
                    max={max}
                    value={threshold}
                    onChange={(val) => setThreshold(val ?? 0)}
                />
            </Flex>
        </>
    )
}
